export const ORDER_ICON = {
	COFFEE: 'coffee',
	SODA: 'soda',
} as const;
export type TOrderIcon = typeof ORDER_ICON[keyof typeof ORDER_ICON];
